import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    onUpdateColumn,
    setOrder,
    setSelectedRow
} from '../../../store/channelmap/reporteseguimiento/actions';
import {sort_by} from '../../../helpers/commons'

import { FieldSet, Table } from '@sigeco/tools';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column'
    }, 
    tableWrap: {
        flex: '1 1 auto'
    }
}));

const ReporteSeguimientoList = () => {
    const classes = useStyles();
    const columns = useSelector(state => state.reporteseguimiento.table.columns);
    const loading = useSelector(state => state.reporteseguimiento.store.loading);
    const order = useSelector(state => state.reporteseguimiento.table.order);
    const orderBy = useSelector(state => state.reporteseguimiento.table.orderBy);
    const store = useSelector(state => state.reporteseguimiento.store);
    const dispatch = useDispatch();

 
    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        dispatch(setOrder(isAsc ? 'desc' : 'asc', property));
        let homes = store.data;
        homes.sort(sort_by(property, isAsc, homes[0][property]));
    };

    const handleResizeColumn = (column) => {
        dispatch(onUpdateColumn(column))
    };

    return (
        <>
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados">
            <div className={classes.tableWrap}>
                <Table
                    columns={columns}
                    count={store.total}
                    loading={loading}
                    onRowClick={items => dispatch(setSelectedRow(items))}
                    onSort={datakey => handleRequestSort(datakey)}
                    onUpdateColumn={handleResizeColumn}
                    rowCount={store.data.length}
                    rowGetter={index => store.data[index]}
                    selected={store.selected}
                    sortBy={orderBy}
                    sortDirection={order}
                />
            </div>
        </FieldSet>

          </>      
    )
};

export default ReporteSeguimientoList;